/**
 * Created by junwon on 2017. 2. 21..
 */
import { Component, OnInit, Injectable, ViewChild } from "@angular/core";
import { Http, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/switchMap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ModalDirective } from "ng2-bootstrap";

// KoHeaderComponent
@Component({
  selector: "header.ko",
  templateUrl: "header.html",
})
export class KoHeaderComponent {}

@Component({
  selector: "footer.ko",
  templateUrl: "footer.html",
})
export class KoFooterComponent {}

// KoHomeComponent
@Component({
  templateUrl: "home.html",
})
export class KoHomeComponent {}

// KoIntroComponent
@Component({
  templateUrl: "intro.html",
})
export class KoIntroComponent {}

// KoSpeakersComponent
@Component({
  templateUrl: "speakers.html",
})
export class KoSpeakersComponent {}

@Injectable()
export class KoRegService {
  constructor(private http: Http) {}

  SERVER_HOST = "https://api.missioncamp.net/";

  submit(regform) {
    return this.http
      .post(this.SERVER_HOST + "api/v1/members/ga/2025/2", regform)
      .toPromise();
  }

  editRegistration(member_idx, regform) {
    return this.http
      .put(this.SERVER_HOST + "api/v1/member/" + member_idx, regform)
      .toPromise();
  }

  kakaoGetUserInfo(access_token) {
    return this.http
      .post(this.SERVER_HOST + "api/v1/oauth/kakao-get-userinfo", {
        access_token: access_token,
      })
      .toPromise();
  }

  listRegistrations(kakao_id) {
    return this.http
      .get(this.SERVER_HOST + "api/v1/members/ga/2025/2?kakao_id=" + kakao_id)
      .toPromise();
  }

  cancelRegistration(member_idx, cancel_reason) {
    return this.http
      .post(this.SERVER_HOST + "api/v1/member/cancel", {
        member_idx: member_idx,
        cancel_reason: cancel_reason,
      })
      .toPromise();
  }

  recoverRegistration(member_idx) {
    return this.http
      .post(this.SERVER_HOST + "api/v1/member/recover", {
        member_idx: member_idx,
      })
      .toPromise();
  }
}

@Injectable()
export class KoOAuthService {
  constructor(private http: Http) {}

  SERVER_HOST = "https://api.missioncamp.net/";

  kakaoRequestToken(client_id, redirect_uri, code, state) {
    return this.http.post(this.SERVER_HOST + "api/v1/oauth/kakao-login", {
      grant_type: "authorization_code",
      client_id: client_id,
      code: code,
      redirect_uri: redirect_uri,
      state: state,
    });
  }

  kakaoRefreshToken(client_id, refresh_token) {
    return this.http.post(
      this.SERVER_HOST + "api/v1/oauth/kakao-get-userinfo",
      {
        grant_type: "refresh_token",
        client_id: client_id,
        refresh_token: refresh_token,
      }
    );
  }
}

@Component({
  template: "Authenticating OAuth User...",
  providers: [KoOAuthService],
})
export class KoOAuthComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private koOAuthService: KoOAuthService
  ) {}

  ngOnInit() {
    let code: string = "";
    let state: string = "";
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      code = params["code"];
      state = params["state"];

      if (code !== undefined) {
        this.koOAuthService
          .kakaoRequestToken(
            "5ab9122d3950c6625ff9a5a8bba4adb8",
            "http://www.btjkorea.org/ko/kakao-oauth",
            code,
            state
          )
          .toPromise()
          .then((response) => {
            let data = response.json();
            Cookie.set("kakaoAccessToken", data["access_token"]);
            Cookie.set("kakaoRefreshToken", data["refresh_token"]);
            this.router.navigateByUrl("/ko/registration");
          });
      }
    });
  }
}

// KoRegComponent
@Component({
  templateUrl: "registration.html",
  providers: [KoRegService],
})
export class KoRegComponent implements OnInit {
  regform: {};
  hp1: string;
  hp2: string;
  hp3: string;
  kakaoUsername: string;
  kakaoId: string;
  accessToken: string;
  isSubmitting: boolean;

  constructor(private router: Router, private koRegService: KoRegService) {}

  ngOnInit() {
    this.isSubmitting = false;
    this.accessToken = Cookie.get("kakaoAccessToken");
    // let refreshToken = Cookie.get('kakaoRefreshToken');

    if (this.accessToken !== undefined) {
      this.koRegService
        .kakaoGetUserInfo(this.accessToken)
        .then((response) => {
          let result = response.json();
          this.kakaoUsername = result.properties.nickname;
          this.kakaoId = result.id;
          this.regform["kakao_user_id"] = result.id;
        })
        .catch(() => this.clearKakoToken());
    }

    this.clearForm();
  }

  clearKakoToken() {
    this.accessToken = "";
    Cookie.delete("kakaoToken");
    Cookie.delete("kakaoAccessToken");
    Cookie.delete("kakaoRefreshToken");
    this.router.navigateByUrl("/ko/registration");
  }

  clearForm() {
    this.hp1 = "010";
    this.regform = {
      sex: "F",
      location: "국내",
      cityselect: "지부",
      city: "지부",
      fullcamp_yn: "1",
      persontype: "",
      etcperson: "",
      date_of_arrival: "2025-05-07",
      date_of_leave: "2025-05-09",
      mit_yn: "1",
      language: "필요 없음",
      route: [],
      ga_experience: [],
    };
  }

  submitForm() {
    this.isSubmitting = true;
    this.regform["contact"] = this.hp1 + "-" + this.hp2 + "-" + this.hp3;

    // if (this.regform["fullcamp_yn"] == "1") {
    //   // 전체 참석
    //   if (this.regform["mit_yn"] == "0") {
    //     // 전체 참석이지만 비전캠프 참석하지 않는 경우
    //     this.regform["date_of_arrival"] = "2025-05-07";
    //     this.regform["date_of_leave"] = "2025-05-09";
    //   } else {
    //     // 전체 참석 + 비전캠프 참석
    //     this.regform["date_of_arrival"] = "2025-05-07";
    //     this.regform["date_of_leave"] = "2025-05-10";
    //   }
    // } else {
    //   // 전체 참석이 아닌 경우, 캠프 참석기간을 전체 날짜로 선택했을때 알림을 표시합니다.
    //   if (
    //     this.regform["date_of_arrival"] === "2025-05-07" &&
    //     this.regform["date_of_leave"] === "2025-05-10"
    //   ) {
    //     alert("참석기간을 확인해주세요. (전체 참석 날짜로 선택되었습니다.)");
    //     this.isSubmitting = false;
    //     return;
    //   }
    // }
    if (this.regform["fullcamp_yn"] == "1") {
      // 전체 참석
      this.regform["date_of_arrival"] = "2025-05-07";
      this.regform["date_of_leave"] = "2025-05-09";
    } else {
      // 전체 참석이 아닌 경우, 캠프 참석기간을 전체 날짜로 선택했을때 알림을 표시합니다.
      if (
        this.regform["date_of_arrival"] === "2025-05-07" &&
        this.regform["date_of_leave"] === "2025-05-09"
      ) {
        alert("참석기간을 확인해주세요. (전체 참석 날짜로 선택되었습니다.)");
        this.isSubmitting = false;
        return;
      }
    }

    if (this.regform["name"] === undefined) {
      alert("이름을 기입해주시기 바랍니다.");
      this.isSubmitting = false;
      return;
    }

    // if (this.regform["enname"] === undefined) {
    //   alert("영문 이름을 기입해주시기 바랍니다. ");
    //   this.isSubmitting = false;
    //   return;
    // }

    if (this.regform["city"] === "지부") {
      alert("지역(지부)를 선택해주시길 바랍니다.");
      this.isSubmitting = false;
      return;
    }

    if (this.regform["city"] === undefined) {
      alert("거주중인 도시(지역)을 기입해주시기 바랍니다");
      this.isSubmitting = false;
      return;
    }

    if (this.hp2 === undefined || this.hp3 === undefined) {
      alert("연락처를 기입해주시기 바랍니다.");
      this.isSubmitting = false;
      return;
    }

    if (this.regform["church"] === undefined) {
      alert("소속 교회를 기입해주시기 바랍니다");
      this.isSubmitting = false;
      return;
    }

    if (this.regform["persontype"] == "") {
      alert("참가구분을 선택해주시기 바랍니다.");
      this.isSubmitting = false;
      return;
    }

    if (
      this.regform["persontype"] == "비목회자" &&
      this.regform["etcperson"] == ""
    ) {
      alert("세부 구분을 선택해주시기 바랍니다");
      this.isSubmitting = false;
      return;
    }

    if (this.regform["denomination"] === undefined) {
      alert("교단을 기입해주시기 바랍니다");
      this.isSubmitting = false;
      return;
    }

    this.koRegService
      .submit(this.regform)
      .then(() => {
        alert("신청이 완료되었습니다.");

        // 신청 완료 후 폼 초기화
        this.clearForm();
        this.isSubmitting = false;
      })
      .catch((e) => {
        alert(
          `신청 오류입니다. 오류가 지속될 경우 지부에 문의하세요.\n 오류정보: ${e}`
        );
        console.error(e);
        this.isSubmitting = false;
      });
  }
}

// KoRegManageComponent
@Component({
  templateUrl: "reg_manage.html",
  providers: [KoRegService],
})
export class KoRegManageComponent implements OnInit {
  kakao_id: string;
  regArray = [];
  itemIndex: number;
  selectedItem = {};
  regform = {};
  hp1: string;
  hp2: string;
  hp3: string;

  @ViewChild("editModal") editModal: ModalDirective;
  @ViewChild("cancelModal") cancelModal: ModalDirective;
  @ViewChild("reregModal") reregModal: ModalDirective;
  @ViewChild("successModal") successModal: ModalDirective;
  @ViewChild("failedModal") failedModal: ModalDirective;

  success_message: string;
  failed_message: string;

  constructor(
    private route: ActivatedRoute,
    private koRegService: KoRegService
  ) {}

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    this.route.params
      .switchMap((params) =>
        this.koRegService.listRegistrations(params["kakao_id"])
      )
      .subscribe((response) => (this.regArray = response.json()));
  }

  selectItem(index: number) {
    this.selectedItem = this.regArray[index];
  }

  selectedItemToRegform(index: number) {
    let item = this.regArray[index];

    this.hp1 = item.contact.split("-")[0];
    this.hp2 = item.contact.split("-")[1];
    this.hp3 = item.contact.split("-")[2];
    this.regform = {
      name: item.name,
      enname: item.meta.enname,
      email: item.email,
      sex: item.sex,
      location: item.meta.location,
      city: item.meta.city,
      church: item.church,
      address: item.meta.address,
      persontype: item.persontype,
      etcperson: item.meta.etcperson,
      denomination: item.meta.denomination,
      date_of_arrival: item.date_of_arrival,
      date_of_leave: item.date_of_leave,
      route: item.meta.route,
      ga_experience: item.meta.ga_experience,
      language: item.language,
      etclanguage: item.meta.etclanguage,
      pname: item.meta.pname,
      memo: item.memo,
      kakao_user_id: item.kakao_user_id,
    };

    if (item.fullcamp_yn) this.regform["fullcamp_yn"] = "1";
    else this.regform["fullcamp_yn"] = "0";
    if (item.mit_yn) this.regform["mit_yn"] = "1";
    else this.regform["mit_yn"] = "0";
  }

  cancelRegistration(member_idx: number, cancel_reason: string) {
    this.koRegService
      .cancelRegistration(member_idx, cancel_reason)
      .then((response) => {
        let result = response.json();
        this.loadList();
        this.success_message = result.message;
        this.cancelModal.hide();
        this.successModal.show();
      })
      .catch((response) => {
        let error = response.json();
        this.failed_message = error.message;

        this.cancelModal.hide();
        this.failedModal.show();
      });
  }

  recoverRegistration(member_idx: number) {
    this.koRegService
      .recoverRegistration(member_idx)
      .then((response) => {
        let result = response.json();
        this.loadList();
        this.success_message = result.message;
        this.reregModal.hide();
        this.successModal.show();
      })
      .catch((response) => {
        let error = response.json();
        this.failed_message = error.message;

        this.reregModal.hide();
        this.failedModal.show();
      });
  }

  editRegistration(member_idx: number) {
    this.regform["contact"] = this.hp1 + "-" + this.hp2 + "-" + this.hp3;

    this.koRegService
      .editRegistration(member_idx, this.regform)
      .then((response) => {
        let result = response.json();
        this.loadList();
        this.success_message = result.message;
        this.editModal.hide();
        this.successModal.show();
      })
      .catch((response) => {
        let error = response.json();
        this.failed_message = error.message;
        this.editModal.hide();
        this.failedModal.show();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/ko/ko.component.ts